module.exports = __webpack_public_path__ + "media/images/riders/AMAURY_PIERRON-c62ee55555981efc39319d4f33132c31.png";